import { Tag } from '@cian/components';
import * as React from 'react';

import { isCommercial } from '../../../../utils/category';
import { ITotalFloorsTag } from '../../../state/tags/definitions/total_floors';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ITotalFloorsTagItemProps {
  tag: ITotalFloorsTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const TotalFloorsTagItem = (props: ITotalFloorsTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);
  let text = [];

  if (props.tag.min !== undefined) {
    text.push(`от ${props.tag.min}`);
  }

  if (props.tag.max !== undefined) {
    text.push(`до ${props.tag.max}`);
  }

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Этажей в {!isCommercial(props.tag.offerType) ? 'доме' : 'здании'} {text.join(' ')}
    </TagComponent>
  );
};
